import { render, staticRenderFns } from "./NumberOfTerms.vue?vue&type=template&id=00537f15&"
import script from "./NumberOfTerms.vue?vue&type=script&lang=js&"
export * from "./NumberOfTerms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports